export enum PriceDropZonesEnum {
  CONVERSION_VERY_UNDERPRICED = 'pricedrop-conversion-very-underpriced',
  CONVERSION_UNDERPRICED = 'pricedrop-conversion-underpriced',
  CONVERSION_AT_PRICE = 'pricedrop-conversion-at-reco',
  CONVERSION_WELL_PRICED = 'pricedrop-conversion-well-priced',
  CONVERSION_OVERPRICED = 'pricedrop-conversion-overpriced',
  CONVERSION_VERY_OVERPRICED = 'pricedrop-conversion-very-overpriced',
}
